export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ffc6f9ee5c55c3a96cd98317df417bc242c4a2b3e&name=fetchTypeahead!'